import {News} from "@interfaces/news";
import {Event} from "@interfaces/event";
import {Owner} from "@interfaces/owner";
import {Location} from "@interfaces/location";
import {parseJSON} from "date-fns";

export class TimelineEntry {
  created_at: Date;
  description: string | null;
  event_date_start: Date;
  event_date_end: Date | null;
  id: string;
  images: string[];
  owner: Owner;
  title: string;
  slug: string;
  type: 'event' | 'news';
  locations: Location[];
  likes: number;
  is_liked_by_user: boolean;

  constructor(entry: News | Event) {
    this.id = entry.id;
    this.images = entry.images;
    this.owner = entry.owner;
    this.title = entry.title;
    this.slug = entry.slug;
    this.created_at = parseJSON(entry.created_at);
    this.description = entry.description;
    // @ts-ignore
    this.event_date_start = entry.hasOwnProperty('event_date_start') ? entry.event_date_start as Date : new Date();
    this.event_date_end = null;
    this.type = 'news';
    this.locations = entry.locations;
    this.likes = entry.likes;
    this.is_liked_by_user = entry.is_liked_by_user;

    if ((entry as Event).event_date_start) {
      this.type = 'event';
      this.event_date_start = parseJSON((entry as Event).event_date_start);
    }
    if ((entry as Event).event_date_end && (entry as Event).event_date_end !== null) {
      this.event_date_end = parseJSON(<string>(entry as Event).event_date_end);
    }
  }

  getMainImage(): string | null {
    if (this.images.length > 0) {
      return this.images[0]
    }

    if (this.owner.header) {
      return this.owner.header;
    }

    return null;
  }


  getLink(): string {
    const path = this.type === 'event' ? 'events' : 'news';

    if (this.owner.type === 'app') {
      return this.owner.slug;
    }

    return `/${path}/${this.owner.slug}/${this.slug}`;
  }

  toNews(): News {
    return {
      id: this.id,
      images: this.images,
      owner: this.owner,
      title: this.title,
      description: this.description,
      slug: this.slug,
      created_at: this.created_at.toISOString(),
      locations: this.locations,
      likes: this.likes,
      is_liked_by_user: this.is_liked_by_user,
    } as News;
  }

  toEvent() {
    return {
      id: this.id,
      images: this.images,
      owner: this.owner,
      title: this.title,
      description: this.description,
      slug: this.slug,
      event_date_start: this.event_date_start.toISOString(),
      event_date_end: this.event_date_end?.toISOString() || null,
      locations: this.locations,
      likes: this.likes,
      is_liked_by_user: this.is_liked_by_user,
    } as Event;
  }
}
